import { required, minLength, integer, maxLength } from 'vuelidate/lib/validators'
import { validateRegexData, validateRegexComputed } from './validateRegex'

export const validateData = {
  form: {
    ...validateRegexData,
    acao: {
      description: { required, maxLength: maxLength(35) },
      centroDeCusto: { required },
      senha: { required, minLength: minLength(4), integer },
    },
  },
}

export const validateComputed = {
  ...validateRegexComputed,
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.acao.description.$dirty) return errors
    !this.$v.form.acao.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.acao.description.maxLength && errors.push('Máximo 35 caracteres.')
    return errors
  },
  centroDeCustoErrors() {
    const errors = []
    if (!this.$v.form.acao.centroDeCusto.$dirty) return errors
    !this.$v.form.acao.centroDeCusto.required && errors.push('Centro de custo é obrigatório.')
    return errors
  },
  senhaErrors() {
    const errors = []
    if (!this.$v.form.acao.senha.$dirty) return errors
    !this.$v.form.acao.senha.required && errors.push('Senha é obrigatória.')
    !this.$v.form.acao.senha.integer && errors.push('Senha deve ter apenas caracteres numéricos.')
    !this.$v.form.acao.senha.minLength && errors.push('Senha deve ter pelo menos 4 dígitos.')
    return errors
  },
}
